import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { formatCurrency } from '../../../utils/mathUtils';

export const useGetColumns = () => {

    const columns = [
        {
            field: 'idConexion',
            headerName: 'N° Conexión',
            flex: 130
        },
        {
            field: 'estado',
            headerName: 'Estado',
            flex: 90
        },
        {
            field: 'fechaConexion',
            headerName: 'Fecha Conexión',
            type: 'date',
            flex: 140
        },
        {
            field: 'idEvaluacion',
            headerName: 'N° Contrato',
            flex: 110
        },
        {
            field: 'precioDiario',
            headerName: 'Precio Diario',
            flex: 120,
            valueGetter: (value) => {
                return formatCurrency(value);
            }
        },
        {
            field: 'paciente',
            headerName: 'Paciente',
            flex: 200,
        }
    ]

    const configuratedColumns = generateColumnsDefaultConfiguration(columns, true);

    return configuratedColumns;
}
